import { render, staticRenderFns } from "./courseResourceManagement.vue?vue&type=template&id=05d6f22a"
import script from "./courseResourceManagement.vue?vue&type=script&lang=js"
export * from "./courseResourceManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports